import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  customDecode,
  customDecrypt,
  greaterThanZeroValidator,
  noWhitespaceValidator,
  nonNegativeValidator,
} from '@piqet-angular/data';
import { AccessPermissionService, CustomModalService } from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';

@Component({
  selector: 'piqet-angular-add-product-eol',
  templateUrl: './add-product-eol.component.html',
  styleUrls: ['./add-product-eol.component.scss'],
})
export class AddProductEolComponent {
  modalLabel: any;
  EOLData: any;
  EOLAddEditForm!: FormGroup;
  @Output() saveProductEOL = new EventEmitter<any>();
  wasteIdentifierList: any;
  countryList: any;
  selectedCountry: any;
  selectedIdentifier: any;
  submitted: boolean = false;
  productId: any;
  editedWasteItem: any;
  editedCountryItem: any;
  showEdit: boolean = false;
  countryId: any;
  productEOLData: any;
  errorMessage = '';
  constructor(
    private readonly modal: CustomModalService,
    private readonly formBuilder: FormBuilder,
    private readonly projectsService: ProjectsService,
    private readonly accessService: AccessPermissionService,
    private readonly route: ActivatedRoute
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.EOLData = this.modal?.modalService?.config?.initialState?.['newEOLData'];
    this.countryId = this.modal?.modalService?.config?.initialState?.['countryId'];
    this.productEOLData = this.modal?.modalService?.config?.initialState?.['productEOLData'];

    this.productId = customDecrypt(this.route.snapshot.queryParams['param'])?.id;
    this.getWasteIdentifierItem();
    this.getCountryItem();
  }

  ngOnInit(): void {
    this.showEdit = this.accessService.hasPermission('edit', '');
    this.EOLAddEditForm = this.formBuilder.group({
      wasteIdentifier: [null, Validators.required],
      country: [null],
      productWeight: [{ value: null, disabled: true }],
      productDisposal: [
        null,
        [
          Validators.required,
          Validators.max(100),
          nonNegativeValidator,
          greaterThanZeroValidator(),
        ],
      ],
      amtOfProductDisposal: [
        { value: this.EOLData?.amountOfProductDisposed || null, disabled: true },
        Validators.required,
      ],
    });
    this.wasteIdentifierList = this.EOLData.wasteDisposalIdentifierList;
    this.countryList = this.EOLData.countryList;
    this.setFormData();
  }

  setFormData() {
    this.EOLAddEditForm.patchValue({
      wasteIdentifier: this.editedWasteItem,
      country: this.editedCountryItem,
      productWeight: this.EOLData.massOfProductInGram,
      productDisposal: this.EOLData?.productDisposalAtEOL,
      amtOfProductDisposal: this.EOLData?.amountOfProductDisposed,
    });
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  getAmtofProductDisposal() {
    if (this.EOLAddEditForm.controls['productDisposal'].value <= 100) {
      this.projectsService
        .getProductAmountOfProductDisposed(
          this.productId,
          this.EOLAddEditForm.controls['productDisposal']?.value
        )
        .subscribe((res: any) => {
          this.EOLAddEditForm.patchValue({ amtOfProductDisposal: res.data });
        });
    }
  }

  isValidProductDisposalTotal(): boolean {
    const total = this.productEOLData.reduce((sum: number, item: any) => {
      const disposalKeys = Object.keys(item).filter(k => !['id', 'productName'].includes(k));
      const itemTotal = disposalKeys.reduce((acc, key) => {
        const disposalId = key.replace('disposal_', '');
        if (this.EOLData?.id && Number(disposalId) === this.EOLData.id) {
          return acc;
        }
        return acc + (+item[key] || 0);
      }, 0);
      return sum + itemTotal;
    }, 0);

    const productDisposalAtEOL = +this.EOLAddEditForm.controls['productDisposal'].value || 0;
    const grandTotal = total + productDisposalAtEOL;

    if (grandTotal > 100) {
      return false;
    }

    return true;
  }

  onSave() {
    this.submitted = true;
    if (!this.isValidProductDisposalTotal()) {
      this.errorMessage = 'End of life total is not greater than 100%.';
      return;
    }
    this.errorMessage = '';
    if (this.EOLAddEditForm.valid) {
      const payload = {
        id: this.EOLData?.id ?? 0,
        productId: Number(this.productId),
        wasteDisposalId: this.selectedIdentifier ?? this.EOLData?.wasteDisposalId,
        countryId: this.countryId ?? this.EOLData?.countryId,
        productDisposalAtEOL: this.EOLAddEditForm.controls['productDisposal'].value,
        massOfProductInGram: this.EOLAddEditForm.controls['productWeight'].value,
        amountOfProductDisposed: this.EOLAddEditForm.controls['amtOfProductDisposal'].value,
      };
      this.saveProductEOL.emit(payload);
    }
  }

  async getWasteIdentifierItem() {
    await this.EOLData.wasteDisposalIdentifierList.map((item: any) => {
      if (item.id == this.EOLData.wasteDisposalId) {
        return (this.editedWasteItem = item);
      }
    });
  }

  async getCountryItem() {
    await this.EOLData.countryList.map((item: any) => {
      if (item.id == this.countryId) {
        return (this.editedCountryItem = item);
      } else if (this.countryId == 0 && this.productEOLData.length == 0) {
        return (this.editedCountryItem = this.EOLData.countryList[0]);
      }
    });
  }

  selectedWasteIdentifier(eve: any) {
    if (eve.id) {
      this.selectedIdentifier = eve.id;
    }
  }

  selectedNation(eve: any) {
    if (eve.id) {
      this.selectedCountry = eve.id;
    }
  }
}
